module.exports = __webpack_public_path__ + "img/Elderberry.cb04736c.png";